'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Dialog = require('../Dialog/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _FloatingButton = require('../FloatingButton/FloatingButton');

var _FloatingButton2 = _interopRequireDefault(_FloatingButton);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO : eliminare intl

var ButtonDialog = function (_React$Component) {
  _inherits(ButtonDialog, _React$Component);

  function ButtonDialog(props) {
    _classCallCheck(this, ButtonDialog);

    var _this = _possibleConstructorReturn(this, (ButtonDialog.__proto__ || Object.getPrototypeOf(ButtonDialog)).call(this, props));

    _this.state = {
      open: false
    };
    _this.handleOpen = _this.handleOpen.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.renderButton = _this.renderButton.bind(_this);
    _this.renderDialog = _this.renderDialog.bind(_this);
    return _this;
  }

  _createClass(ButtonDialog, [{
    key: 'handleOpen',
    value: function handleOpen() {
      this.setState({ open: true });
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      this.setState({ open: false });
    }
  }, {
    key: 'renderDialog',
    value: function renderDialog() {
      var result = null;

      var _props = this.props,
          dialog = _props.dialog,
          button = _objectWithoutProperties(_props, ['dialog']);

      var title = dialog.title,
          dialogProps = _objectWithoutProperties(dialog, ['title']);

      var messages = this.props.intl.messages;

      if (this.state.open) {
        result = _react2.default.createElement(_Dialog2.default, _extends({
          onRequestClose: this.handleClose,
          onCancel: this.handleClose
        }, dialogProps, {
          title: messages[title] || title,
          open: true
        }));
      }
      return result;
    }
  }, {
    key: 'renderButton',
    value: function renderButton() {
      var result = void 0;

      var _props2 = this.props,
          dialog = _props2.dialog,
          button = _objectWithoutProperties(_props2, ['dialog']);

      switch (button.type) {
        case 'icon':
          result = _react2.default.createElement(
            _IconButton2.default,
            _extends({
              onClick: this.handleOpen,
              iconClassName: 'material-icons'
            }, button),
            button.icon
          );
          break;
        default:
          result = _react2.default.createElement(_FloatingButton2.default, _extends({}, button, { onClick: this.handleOpen }));
      }
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderButton(),
        this.renderDialog()
      );
    }
  }]);

  return ButtonDialog;
}(_react2.default.Component);

ButtonDialog.propTypes = {
  intl: _reactIntl.intlShape.isRequired,
  button: _react2.default.PropTypes.string,
  children: _react2.default.PropTypes.any
};
exports.default = (0, _reactIntl.injectIntl)(ButtonDialog);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/ButtonDialog/ButtonDialog.js
 ** module id = 487
 ** module chunks = 0
 **/